import { getRoute, PATH } from '@/utils/routes';
import router from 'next/router';
import { useSelector } from 'react-redux';

export const BreadcrumbComp = props => {
  const { store_info } = useSelector(state => state.storeReducer.store);

  const homeClick = () => {
    router.push(getRoute(PATH.PRODUCT, store_info?.domain));
  };

  return (
    <div
      className={`pointer category-breadcrumb ${props?.classes || ''}`}
      {...props}
      onClick={homeClick}
    >
      <span className="mr2 relative">
        Home<span className="bottomborder"></span>
      </span>{' '}
      /
    </div>
  );
};
